import React, { useState,useEffect } from "react";
import { Button, Checkbox, Form, Input ,Divider,Spin} from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import store from "@/util/store";
import {getSignIn} from "@/util/http/Quantis/index";
import "./index.less";
import { weevilTrakLogin } from "@/util/http/WeevilTrak";
import { useDispatch } from "react-redux";
import { updateCommonErrorMessage } from "@/redux/actions/weevilTrakAction";

const Login = ()=>{
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const [loadding,setLoading] = useState(false);

    const onLoginButtonClick = async()=>{
        setLoading(true);
        try{
            const res = await weevilTrakLogin({
                email: form.getFieldValue("email"),
                password: form.getFieldValue("password")
            });
            if(res.data && res.data.token){
                localStorage.setItem("weeviltrak-token", res.data.token);
                localStorage.setItem("weeviltrak-useremail", res.data.user?.email);
                localStorage.setItem("weeviltrak-username", res.data.user?.firstName + " " + res.data.user?.lastName);
                localStorage.setItem("weeviltrak-userroles", JSON.stringify(res.data.user?.roles || []));
                navigate("/weeviltrak/home");
            }
        }
        catch(error:any){
            dispatch(updateCommonErrorMessage(error?.response?.data || "Login failed. Please check your credentials and try again."));
        }
        finally{
            setLoading(false);
        }

    };
    const [saveUser,setSaveUser] = useState<boolean>(false);
    const check = (e)=>{
        setSaveUser(e.target.checked);
    };
    const onFinish = (values: any) => {
        if(saveUser){
            store.set("quantisRemember",values);
        }
    };
    // useEffect(() => {
    //     const quantisRemember:any = store.get("quantisRemember");
    //     if(quantisRemember!=undefined){
    //         form.setFieldsValue({
    //             email: quantisRemember.email,
    //             Password: quantisRemember.Password
    //         });
    //         // setEmail(quantisRemember.email);
    //         // setPassword(quantisRemember.Password);
    //     }

    // }, [location]);
    return (
        <div className="login-style" >
            <Spin spinning={loadding} size="large">
                <Form
                    name="basic"
                    form={form}
                    labelCol={{ span: 16 }}
                    layout="vertical"
                    onFinish={onFinish}
                    autoComplete="off"
                    initialValues={{
                        email: "",
                        Password: ""
                    }}
                    style={{
                        marginTop: "50px",
                        padding: "20px 30px",
                        // border: "1px solid rgb(217, 217, 217)",
                        border: "1px solid rgb(89, 185, 72)",
                        borderRadius: "5px"
                    }}
                >
                    <Divider>
                        <p>Please Sign In</p>
                    </Divider>
                    <Form.Item
                        label="Email address"
                        name="email"
                        rules={[
                            { required: true, message: "Please input your Email!" },
                            {pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,message: "Incorrect format!",max:50}
                        ]}
                    >
                        <Input placeholder="Email address"
                            prefix={<UserOutlined className="site-form-item-icon" />}
                            onChange={(e)=>{
                            // setEmail(e.target.value);
                            }} />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        label="Password"
                        rules={[{ required: true, message: "Please input your Password!" }]}
                        style={{marginBottom: "10px"}}
                    >
                        <Input.Password
                            placeholder="Password"
                            onChange={(e)=>{
                            // setPassword(e.target.value);
                            }} />
                    </Form.Item>

                    <Form.Item style={{marginBottom: "10px"}}>
                        {/* <Form.Item valuePropName="checked" noStyle>
                        <Checkbox onChange={e=>check(e)}>Remember me</Checkbox>
                    </Form.Item> */}

                        <a className="forgot-password-link" onClick={e => {navigate("/weeviltrak/forgot");}}>
                        Forgot password
                        </a>
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" className="login-button"
                            style={{marginBottom: "5px"}}
                            onClick={onLoginButtonClick}
                        >
                        Login
                        </Button>
                        <p className="no-account-note">Don&apos;t have an account?
                            <a onClick={e => {navigate("/weeviltrak/signup");}}>{" Sign Up"}</a></p>
                    </Form.Item>
                </Form>
            </Spin>

        </div>
    );
};


export default Login;